import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Loading } from './components/loader/loading';
import { Route } from 'react-router';
import './custom.css'
import './theme.css'
import Layout from './components/Layout/Layout';

import Clientes from './views/clientes/Clientes';
import Pedidos from './views/pedidos/pedidos';
import Gestao from './views/gestao/gestao';
import Recibo from './views/recibo/recibo';
import ListaRecibo from './views/listaRecibo/listaRecibo';
import Login from './views/login/login';
import CadUsuario from './views/cadUsuario/cadUsuario';
import Produtos from './views/produtos/produtosTable';
import Usuarios from './views/usuarios';
import Estoque from './views/estoque/estoque';
import MateriaPrima from './views/materiaPrima/materiaPrima';

import { CiBoxes } from "react-icons/ci";
import { FaCamera, FaUsers, FaDev, FaShoppingCart, FaRegFileAlt, FaHistory, FaUser, FaBoxes, FaFile, FaTruckLoading } from 'react-icons/fa';
import { BsInboxesFill } from 'react-icons/bs';
import { FaBoxesPacking, FaCalendar, FaGears } from 'react-icons/fa6';
import ResetarSenha from './views/resetarSenha/ResetarSenha';
import FechamentoMes from './views/fechamentoMes';
import ArquivoPedido from './views/arquivoPedido/ArquivoPedido';
import BloquearClientes from './views/bloquearClientes/BloquearClientes';
import { MdBlockFlipped, MdFactCheck } from 'react-icons/md';
import GestaoMotoristaVendedor from './views/gestao/motorista-vendedor/GestaoMotoristaVendedor';
import Deposito from './views/Deposito/Deposito';
import BaixaBoleto from './views/baixaBoleto/BaixaBoleto';
import BarcodeScanner from './views/codigoBarras/codigoBarras';
import BuscarRecibos from './views/relatorios/RelatorioRecibo';
import { HiOutlineDocumentReport } from "react-icons/hi";


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

createRoot(rootElement).render(
  <BrowserRouter basename={baseUrl}>
    <Loading />
    <Route exact path='/' component={(props) => (
      <Layout Icon={<FaUsers color='#fff' size={25} />} Tela="Clientes">
        <Clientes {...props} />
      </Layout>
    )} />
    <Route exact path='/cliente' component={(props) => (
      <Layout Icon={<FaUsers color='#fff' size={25} />} Tela="Clientes">
        <Clientes {...props} />
      </Layout>
    )} />
    <Route exact path='/gestao/motorista-vendedor' component={(props) => (
      <Layout Icon={<FaTruckLoading color='#fff' size={25} />} Tela="Gestão Motorista/Vendedor">
        <GestaoMotoristaVendedor {...props} />
      </Layout>
    )} />
    <Route exact path='/estoqueCarvao' component={(props) => (
      <Layout Icon={<BsInboxesFill size={25} color='#fff' />} Tela="Estoque">
        <Estoque {...props} />
      </Layout>
    )} />
    <Route exact path='/login' component={(props) => (
      <Login {...props} />
    )} />
    <Route exact path='/pedido' component={(props) => (
      <Layout Icon={<FaShoppingCart color='#fff' size={25} />} Tela="Pedidos">
        <Pedidos {...props} />
      </Layout>
    )} />
    <Route exact path='/gestao' component={(props) => (
      <Layout Icon={<FaGears size={25} color="#fff" />} Tela="Gestão">
        <Gestao {...props} />
      </Layout>
    )} />
    <Route exact path='/recibo' component={(props) => (
      <Layout Icon={<FaRegFileAlt size={25} color='#fff' />} Tela="Recibo">
        <Recibo {...props} />
      </Layout>
    )} />
    <Route exact path='/recibos' component={(props) => (
      <Layout Icon={<FaHistory size={25} color='#fff' />} Tela="Lista de Recibos">
        <ListaRecibo {...props} />
      </Layout>
    )} />
    <Route exact path='/novousuario' component={(props) => (
      <Layout Icon={<FaUser size={25} color='#fff' />} Tela="Cadastro de Usuário">
        <CadUsuario {...props} />
      </Layout>
    )} />
    <Route exact path='/usuarios' component={(props) => (
      <Layout Icon={<FaUsers size={25} color='#fff' />} Tela="Usuários">
        <Usuarios {...props} />
      </Layout>
    )} />
    <Route exact path='/produtos' component={(props) => (
      <Layout Icon={<FaBoxes size={25} color='#fff' />} Tela="Produtos">
        <Produtos {...props} />
      </Layout>
    )} />
    <Route exact path='/ResetarSenha' component={(props) => (
      <ResetarSenha {...props} />
    )} />
    <Route exact path='/fechamento' component={(props) => (
      <Layout Icon={<FaCalendar size={25} color='#fff' />} Tela="Fechamento Do Mês">
        <FechamentoMes {...props} />
      </Layout>
    )} />
    <Route exact path='/materia-prima' component={(props) => (
      <Layout Icon={<CiBoxes size={25} color='#fff' />} Tela="Materia Prima e Sumos">
        <MateriaPrima {...props} />
      </Layout>
    )} />
    <Route exact path='/pedido/arquivos' component={(props) => (
      <Layout Icon={<FaFile size={25} color='#fff' />} Tela="Documentos do pedido">
        <ArquivoPedido {...props} />
      </Layout>
    )} />
    <Route exact path='/bloquear-clientes' component={(props) => (
      <Layout Icon={<MdBlockFlipped size={25} color='#fff' />} Tela="Bloquear Clientes">
        <BloquearClientes {...props} />
      </Layout>
    )} />
    <Route exact path='/deposito' component={(props) => (
      <Layout Icon={<FaBoxesPacking size={25} color='#fff' />} Tela="Depositos">
        <Deposito {...props} />
      </Layout>
    )} />
    <Route exact path='/baixa-boleto' component={(props) => (
      <Layout Icon={<MdFactCheck size={25} color='#fff' />} Tela="Baixa Boleto">
        <BaixaBoleto {...props} />
      </Layout>
    )} />
    <Route exact path='/codigo-barras' component={(props) => (
      <Layout Icon={<FaCamera size={25} color='#fff' />} Tela="Confirmar Entrega">
        <BarcodeScanner {...props} />
      </Layout>
    )} />
    <Route exact path='/relatorio-recibos' component={(props) => (
      <Layout Icon={<HiOutlineDocumentReport size={25} color='#fff' />} Tela="RELATÓRIO RECIBOS">
        <BuscarRecibos {...props} />
      </Layout>
    )} />
    {/* <Route exact path='/deposito/estoque' component={(props) => (
      <Layout Icon={<MdBlockFlipped size={25} color='#fff' />} Tela="Bloquear Clientes">
        <DepositoEstoque {...props} />
      </Layout>
    )} /> */}
  </BrowserRouter>);


const NotFound = () => (
  <div style={{ textAlign: 'center', marginTop: '50px' }}>
    <h1>404 - Página Não Encontrada</h1>
    <p>A página que você está procurando não existe.</p>
    <button onClick={() => window.history.go(-1)} className="btn btn-link">Voltar</button>
  </div>
);
